import { render, staticRenderFns } from "./BorderGradient.vue?vue&type=template&id=1f0f6408&scoped=true"
import script from "./BorderGradient.vue?vue&type=script&lang=js"
export * from "./BorderGradient.vue?vue&type=script&lang=js"
import style0 from "./BorderGradient.vue?vue&type=style&index=0&id=1f0f6408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f6408",
  null
  
)

export default component.exports